import {RGB} from '@wandb/weave/common/util/colors';
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import ColorPicker from '../../../../ColorPicker';

export type OverlaysTableRowProps = {
  title: string;
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  color: RGB;
  setColor?: (color: string) => void;
  'data-test'?: string;
};

export const OverlaysTableRow = ({
  title,
  isVisible,
  setIsVisible,
  color,
  setColor,
  'data-test': dataTest,
}: OverlaysTableRowProps) => {
  const backgroundColor = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
  return (
    <div
      className="mt-16 flex h-32 items-center justify-between first:mt-0"
      data-test={dataTest}>
      <div className="flex items-center">
        <Button
          data-test={`visibility-toggle-${title}`}
          variant="ghost"
          icon={isVisible ? 'visible' : 'not-visible'}
          onClick={() => setIsVisible(!isVisible)}
        />
        <div className="ml-4" data-test="overlay-table-row-title">
          {title}
        </div>
      </div>
      <ColorPicker
        activeColor={backgroundColor}
        setColor={setColor}
        readOnly={setColor == null}
        trigger="button"
      />
    </div>
  );
};
